<template>
  <div ref="turnstileWidget"></div>
</template>

<script>
export default {
  name: 'TurnstileWidget',
  methods: {
    loadTurnstile () {
      if (!window.turnstile) {
        const script = document.createElement('script')
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
        script.async = true
        script.defer = true
        script.onload = this.renderWidget
        document.head.appendChild(script)
      } else {
        this.renderWidget()
      }
    },
    renderWidget () {
      if (window.turnstile) {
        window.turnstile.render(this.$refs.turnstileWidget, {
          sitekey: process.env.VUE_APP_TURNSTILE_SITE_KEY || '#{Project.Ui.Turnstile.SiteKey}',
          theme: 'light',
          callback: this.onVerify,
          'error-callback': this.onError
        })
      }
    },
    onVerify (token) {
      this.$emit('verified', token)
    },
    onError () {
      this.$emit('errored')
    },
    resetWidget () {
      if (window.turnstile) {
        window.turnstile.reset(this.$refs.turnstileWidget)
      }
    }
  },
  mounted () {
    this.loadTurnstile()
  }
}
</script>
